import type { Podcast } from "@/lib/podcast/podcast.service";

/**
 * True while the generation / merge pipeline is expected to be running server-side.
 * `PENDING` before cost approval is *not* background work — the user must still
 * confirm in the modal; treating it as processing caused infinite loading + polling.
 */
export function isPodcastPipelineProcessing(
	podcast: Pick<Podcast, "status" | "costApproved"> | null | undefined,
): boolean {
	if (!podcast) return false;
	if (podcast.status === "PROCESSING") return true;
	if (podcast.status === "PENDING") {
		return podcast.costApproved === true;
	}
	return false;
}

export function isPodcastAwaitingCostApproval(
	podcast: Pick<Podcast, "status" | "costApproved"> | null | undefined,
): boolean {
	return podcast?.status === "PENDING" && podcast.costApproved === false;
}
